import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Card, CardActionArea, CardContent, CircularProgress } from '@mui/material';
import apiClient from '../api/client';

const StatCard = ({ title, description, stat, loading, onClick }) => (
  <Card sx={{ flex: 1, minWidth: 200 }}>
    <CardActionArea onClick={onClick} sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <Typography variant="h3" color="primary" gutterBottom>{stat}</Typography>
        )}
        <Typography variant="body2" color="text.secondary">{description}</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ properties: null, appointments: null, clients: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      apiClient.get('/properties'),
      apiClient.get('/appointments'),
      apiClient.get('/clients'),
    ]).then(([props, appts, clients]) => {
      setCounts({
        properties: props.data.count,
        appointments: appts.data.count,
        clients: clients.data.count,
      });
    }).finally(() => setLoading(false));
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Dashboard</Typography>
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        <StatCard
          title="Properties"
          description="View and manage listings"
          stat={counts.properties ?? 0}
          loading={loading}
          onClick={() => navigate('/properties')}
        />
        <StatCard
          title="Appointments"
          description="Scheduled showings"
          stat={counts.appointments ?? 0}
          loading={loading}
          onClick={() => navigate('/schedule')}
        />
        <StatCard
          title="Clients"
          description="Registered buyers"
          stat={counts.clients ?? 0}
          loading={loading}
          onClick={() => navigate('/schedule')}
        />
        <StatCard
          title="Map View"
          description="Geographic overview"
          stat="🗺"
          loading={false}
          onClick={() => navigate('/map')}
        />
      </Box>
    </Box>
  );
};

export default Dashboard;
